import axios from 'axios';

const instance = axios.create({
  //baseURL: 'https://cs.beaverglobal.com/wp-json/wp/v2'
  baseURL: 'https://caesarea.com/wp-json/wp/v2'
});

export default instance;